export default {
	/**
	 * Returns an array of translators from the API.
	 * @returns {Promise<array>}
	 */
	async all () {}
};
